import React from "react"
import PropTypes from 'prop-types';

import CssBaseline from '@material-ui/core/CssBaseline';

import { makeStyles } from '@material-ui/styles';

import { Link } from "gatsby"
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import MenuListItems from 'src/components/layout/MenuListItems';

const drawerWidth = 240;

const useStyles = makeStyles(theme => ({
  root: {
    ...theme.flex.row,
    ...theme.flex.justifyCenter,
    minHeight: '100vh',
    backgroundColor: '#fff',
  },
  appBar: {
    ...theme.flex.alignCenter,
    boxShadow: 'none',
    borderBottom: `thin solid #00000030`,
    backgroundColor: theme.header.backgroundColor,
    color: theme.header.fontColor,
    marginLeft: drawerWidth,
  },
  title: {
    color: theme.header.fontColor,
    fontSize: theme.header.fontSize,
    fontFamily: theme.header.fontFamily,
  },
  subTitle: {
    color: '#cbb4fc',
  },
  subTitle2: {
    color: '#9683f0',
  },
  divider: {
    backgroundColor: theme.base.colors.white,
    opacity: '0.4',
  },
  toolbar: {
    ...theme.flex.row,
    ...theme.flex.justifySpaceBetween,
    width: '100%',
    maxWidth: '1032px',
  },
  menuList: {
    height: '100%',
    // marginTop: '15px',
    // justifyContent: 'center',
    // display: 'flex',
  },
  content: {
    ...theme.flex.row,
    ...theme.flex.justifyCenter,
    flexGrow: 1,
    width: '100%',
    marginTop: '57px',              // md 이하: 모바일
    [theme.breakpoints.up('md')]: { // md 이상
      marginTop: '65px'
    }, 
  }
}));

export default function Layout(props) {

  const { title, subTitle, subTitle2, children } = props;
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar className={classes.toolbar}>
          <Typography variant="h6" color="inherit" noWrap>
            <Link       
              className={classes.title}
              to="/">
              {title}
            </Link>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <span className={classes.subTitle}>{subTitle}</span>
            <span className={classes.subTitle2}>{subTitle2}</span>
          </Typography>
          <MenuListItems></MenuListItems>
        </Toolbar>
      </AppBar>
      <main className={classes.content}>
        {children}
      </main>
    </div>
  )
}

Layout.propTypes = {
  container: PropTypes.object,
};
